import { useEffect, useState } from "react";
import { api } from "@/api";
import Shell from "@/components/Shell";
import { visitorNav } from "./VisitorDirectory";
import { Spinner, Overline, Stat } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { Store, CheckCircle2, CalendarDays, Heart, BookMarked, Award } from "lucide-react";

export default function VisitorSummary() {
  const [s, setS] = useState(null);
  const { user } = useAuth();
  useEffect(() => { api.get("/visitor/summary").then(({ data }) => setS(data)); }, []);

  if (!s) return <Shell nav={visitorNav}><Spinner /></Shell>;

  return (
    <Shell nav={visitorNav}>
      <Overline>Post-Event Summary</Overline>
      <h1 className="font-display text-3xl gold-text mt-2">Your JJS Journey</h1>

      <div className="glass rounded-3xl p-6 mt-6 text-center gold-glow fade-up">
        <div className="h-16 w-16 rounded-full btn-gold flex items-center justify-center mx-auto">
          <Award size={30} className="text-[#0B0F12]" />
        </div>
        <h2 className="font-serif-head text-2xl text-slate-100 mt-3">{user?.name}</h2>
        <p className="text-slate-400 text-sm capitalize">{user?.classification} · JJS Exhibition 2026</p>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-6">
        <Stat testid="summary-booths" label="Booths Visited" value={s.booths_visited} icon={Store} />
        <Stat testid="summary-checkins" label="Check-ins" value={s.total_checkins} icon={CheckCircle2} />
        <Stat testid="summary-days" label="Days Active" value={s.days_active} icon={CalendarDays} />
        <Stat testid="summary-favs" label="Favourites" value={s.favourites} icon={Heart} />
      </div>

      <div className="glass rounded-2xl p-5 mt-4" data-testid="summary-saved">
        <div className="flex items-center gap-2 text-slate-300"><BookMarked size={16} className="text-amber-400" /> {s.saved_catalogues} catalogues saved</div>
      </div>

      {s.top_categories.length > 0 && (
        <div className="mt-6">
          <h3 className="font-sub text-sm uppercase tracking-wider text-slate-300 mb-3">Top Interests</h3>
          <div className="flex flex-wrap gap-2">
            {s.top_categories.map((c) => (
              <span key={c.category} className="text-sm px-4 py-2 rounded-full bg-amber-500/10 text-amber-300 border border-amber-500/20" data-testid={`top-cat-${c.category}`}>
                {c.category} · {c.count}
              </span>
            ))}
          </div>
        </div>
      )}
    </Shell>
  );
}
